import axios from "axios"
import currentAuthSession from "../aws/cognito/currentAuthSession"

export const createGlobalFetcher = (accessToken, setSessionAction) => {
    return async (url) => {
        try {
            const res = await axios.get(url, {headers: {Authorization: `Bearer ${accessToken}`}})
            return res.data
        } catch (err) {
            if (err.response?.status === 401) {
                try {
                    await currentAuthSession()
                    .then(async (response) => {
                        setSessionAction({type: "REFRESH_COGNITO_TOKEN", payload: {idToken: response.idToken.toString()}})
                        const newToken = response.idToken.toString()
                        const retryRes = await axios.get(url, {headers: {Authorization: `Bearer ${newToken}`}})
                        return retryRes.data
                    })
                } catch (refreshError) {
                    throw refreshError
                }
            }
            throw err
        }
    }
}